if (__DEV__) {
  require('./pages/select-options/components/SelectOptionsPage');
  require('./pages/select-source/components/SelectSourcePage');
}
// import { last, map, initial, compact } from 'lodash';

import CreateTestWizardContainer from './components/CreateTestWizardContainer';

export default store => ({
  path: 'new-task',
  fullScreenDialog: true,
  indexRoute: {
    onEnter({ location }, replace) {
      return replace(`${location.pathname}/select-source`);
    }
  },
  onEnter(nextState, replace) {
    // do not allow direct navigation to any pages but details (the first page
    // in the wizard)
    if (!nextState.location.pathname.match(/source\/?$/)) {
      replace(
        `/engines/${nextState.params.engineId}/tasks/new-task/select-source`
      );
    }
  },
  component: CreateTestWizardContainer,

  getChildRoutes(nextState, cb) {
    Promise.all([
      import(/* webpackChunkName: "test-wizard" */
      './pages/select-source/components/SelectSourcePage'),
      import(/* webpackChunkName: "test-wizard" */
      './pages/select-options/components/SelectOptionsPage')
    ])
      .then(modules => modules.map(m => m.default))
      .then(([SelectSourcePage, SelectOptionsPage]) =>
        cb(null, [
          {
            path: 'select-source',
            component: SelectSourcePage
          },

          {
            path: 'select-options',
            component: SelectOptionsPage
          }
        ])
      )
      .catch(errorLoading);
  }
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}



// WEBPACK FOOTER //
// ./src/client/plugins/engines/pages/engine-tasks/pages/create-test-wizard/index.js